import { object, number, string, boolean } from "yup";

export interface CustomTagResource {
  id: number;
  isSystem: boolean;
  name: string;
  color: string;
}

export const customTagResourceSchema = object().shape({
  id: number().required(),
  isSystem: boolean().required(),
  name: string().required(),
  color: string().required(),
});
